import { ResearchedTransaction } from '@treasury/domain/accounts';
import { formatUsdCurrency } from '@treasury/utils';
import { format } from 'date-fns';

export class ResearchedTransactionVm extends ResearchedTransaction {
    constructor(public transaction: ResearchedTransaction) {
        super(transaction.source);
    }

    public get accountDisplayLabel() {
        return `${this.accountName}`;
    }

    public get displayDate() {
        return format(new Date(this.date), 'iiii, MMMM d, yyyy');
    }

    public get displayAmount() {
        return formatUsdCurrency(this.amount || 0);
    }

    public get displayCode() {
        return this.transactionCodeDescription;
    }

    public get isDeposit() {
        return this.transactionCodeDescription?.includes('Deposit');
    }
}
